import './index.scss'

const Deadlines = ({selectDeadlines = [], clickItem, isDisabled = false}) => {

  return (
    <div className="deadlines">
      <p className="deadlines__label">
        Selecione os prazos
      </p>
      <div className="deadlines__wrapper minimal-scrollbar">
        {Array.from({ length: 13 }).map((_, index) => {
          const isActive = selectDeadlines.includes(index)
          return (
            <div className={"deadlines__item "+(isActive ? "active" : "")+(isDisabled ? " disabled" : "")}
                 onClick={() => isDisabled ? false :clickItem(index)}
                 key={index}>
              {index === 0 ? "À vista" : index === 1 ? "30 dias" : `${index}x`}
            </div>
          )
        })}
      </div>
    </div>
  )
}
export default Deadlines